import { Link } from 'react-router-dom'
import { routes } from 'src/navigation/routes'

export default function PracticeRow({
  item,
  // active,
  onClick = () => {},
  // actions = {}
}) {
  return (
    <div
      onClick={onClick}
      key={item.id}
      className={`details-item details-item__${item.color}`}
    >
      <div className="details-item__num">{item?.grade?.name ?? ''}</div>
      <div className="details-item__top">
        <span className="details-item__name">{item.title || 'No title'}</span>
        <ul className="details-item__list">
          {/* <li>
            <i className="hb-ico student-ico"></i>
            <span>Student</span>
            <b>{item.students_count || 0}</b>
          </li>
          <li>
            <i className="hb-ico problems-ico"></i>
            <span>Practices:</span>
            <b>{item?.practices_count}</b>
          </li> */}
          <li>
            <i className="hb-ico score-ico" />
            <span>Your score:</span>
            <b>{item?.your_score ?? '-'}</b>
          </li>
        </ul>
      </div>
      <div className="details-item__btns">
        <a href="#" className="second-btn">
          {item?.subject?.name}
        </a>
      </div>
    </div>
  )
}
